<!-- This example requires Tailwind CSS v2.0+ -->
<ol role="list" class=" mat-elevation-z6 mx-auto flex w-full space-x-4 sm:px-6 lg:px-12">
    <li class="flex" matTooltip="Back to landing">
      <div class="flex items-center">
        <a routerLink="/dtpms-landing" class="text-gray-400 hover:text-red-300">
          <!-- Heroicon name: mini/home -->
          <mat-icon class="h-5 w-5 flex-shrink-0" >home
          </mat-icon>
          <span class="sr-only">Home</span>
        </a>
      </div>
    </li>
      <ng-container *ngFor="let men of menuDisplay">

        <li class="flex" matTooltip="Go to {{men.name}}">
          <div class="flex items-center">
            <svg class="h-full w-6 flex-shrink-0 text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <a style="--order:{{ i / 2 + 0.5 }}" routerLinkActive="active-menu" *ngxPermissionsOnly="men.permission" routerLink="{{men.route}}" class="ml-4 text-sm font-medium text-gray-500 hover:text-red-300">{{men.name}}</a>
          </div>
        </li>
      </ng-container>
  </ol>